import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import MovieCard from "../components/MovieCard/MovieCardSort";
import "../assets/styles/css/SortPage.css";
import Loading from "../components/Loading/Loading";
import { GrFormNext } from "react-icons/gr";
import { GrFormPrevious } from "react-icons/gr";

const SortPage = () => {
  const { slugValue } = useParams();
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(window.innerWidth < 700 ? 12 : 10);
  const [fetchHistory, setFetchHistory] = useState({});
  const [seoData, setSeoData] = useState({ titleHead: "", descriptionHead: "" });
  const [titleData, setTitleData] = useState({ titlePage: "" });

  useEffect(() => {
    const handleResize = () => {
      setLimit(window.innerWidth > 500 && window.innerWidth < 1400 ? 12 : 10);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [slugValue]);

  useEffect(() => {
    const fetchMovies = async () => {
      const fetchKey = `${slugValue}-${currentPage}`;
      if (fetchHistory[fetchKey]) {
        setMovies(fetchHistory[fetchKey].movies);
        setSeoData(fetchHistory[fetchKey].seo);
        setTitleData(fetchHistory[fetchKey].titleData);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const path = window.location.pathname.split("/")[1];
        const apiUrl = `https://phimapi.com/v1/api/${path}/${slugValue}?page=${currentPage}&limit=${limit}`;
        const response = await axios.get(apiUrl);

        const moviesData = response.data?.data?.items || [];
        const seoOnPage = response.data?.data?.seoOnPage || { titleHead: "", descriptionHead: "" };
        const titlePage = response.data?.data?.titlePage || "";

        setMovies(moviesData);
        setSeoData(seoOnPage);
        setTitleData({ titlePage });
        setFetchHistory((prev) => ({
          ...prev,
          [fetchKey]: { movies: moviesData, seo: seoOnPage, titleData: { titlePage } },
        }));
      } catch (err) {
        setError(err.message || "Failed to fetch movies");
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, [slugValue, currentPage, limit, fetchHistory]);

  const handlePageChange = (page) => {
    if (page >= 1 && page !== currentPage) {
      setCurrentPage(page);
    }
  };

  if (loading) return <Loading />;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="sort-page">
      <Breadcrumb />
      <h1 className="name-sort">Phim {titleData.titlePage}</h1>
      <p className="page-movie-des">{seoData.descriptionHead}</p>
      <div className="movies-list">
        {movies.length > 0 ? (
          movies.map((movie) => <MovieCard key={movie._id} movie={movie} />)
        ) : (
          <p className="not-found">Không tìm thấy phim nào.</p>
        )}
      </div>
      <div className="pagination-controls">
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          <GrFormPrevious/>
        </button>
        {Array.from({ length: 5 }, (_, index) => (
          <button
            key={index + 1}
            className={currentPage === index + 1 ? "active" : ""}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}
        <button onClick={() => handlePageChange(currentPage + 1)}>
          <GrFormNext/>
        </button>
      </div>
    </div>
  );
};

export default SortPage;
